export const getUnitChannels = (state) => {
  return state.UnitsChannels;
};
